"use client";

import { useSidebar } from "@/components/ui/sidebar";
import { Menu } from "lucide-react";

type MobileSidebarToggleProps = {
  layoutName: string;
};

export function MobileSidebarToggle({ layoutName }: MobileSidebarToggleProps) {
  const { toggleSidebar, isMobile, openMobile } = useSidebar();

  if (!isMobile) return null;

  return (
    <header className="mx-3.5 mt-3.5 flex h-14 shrink-0 items-center gap-2 text-sidebar-foreground sm:mx-5 sm:mt-5">
      <button
        type="button"
        className="flex size-14 shrink-0 items-center justify-center rounded-xl border bg-sidebar transition-colors duration-200 ease-out hover:bg-sidebar-accent hover:text-gray-1100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-primary active:bg-sidebar-accent active:text-gray-1100 motion-reduce:transition-none dark:hover:text-gray-100 dark:active:text-gray-100"
        onClick={toggleSidebar}
        aria-expanded={openMobile}
        aria-haspopup="dialog"
      >
        <Menu aria-hidden="true" className="size-5" />
        <span className="sr-only">Toggle menu</span>
      </button>
      <h2 className="flex h-full min-w-0 flex-1 items-center rounded-xl border bg-sidebar px-4 text-base font-bold text-foreground">
        {layoutName}
      </h2>
    </header>
  );
}
